const DROPDOWN_LIMIT = 200;

export default DROPDOWN_LIMIT;
